export const CONTACT_CTA = `ליצירת קשר`